import {useState} from 'react';
import {NodeMouseHandler} from 'reactflow';
import {Node} from 'reactflow';

import {
  isProcedureRunDesignFlowchartColumnNode,
  ProcedureRunDesignFlowchartColumnNodeData,
} from './ProcedureRunDesignFlowchartColumnNode';
import {
  isProcedureRunDesignFlowchartNode,
  ProcedureRunDesignFlowchartNodeData,
} from './ProcedureRunDesignFlowchartNode';

function isNodeHoverable(
  node: Node
): node is Node<ProcedureRunDesignFlowchartColumnNodeData> | Node<ProcedureRunDesignFlowchartNodeData> {
  return isProcedureRunDesignFlowchartColumnNode(node) || isProcedureRunDesignFlowchartNode(node);
}

export function useProcedureRunDesignFlowchartHover(): {
  hoveredMethodId: string | null;
  hoveredNodeId: string | null;
  onNodeMouseEnter: NodeMouseHandler;
  onNodeMouseLeave: NodeMouseHandler;
} {
  const [hoveredMethodId, setHoveredMethodId] = useState<string | null>(null);
  const [hoveredNodeId, setHoveredNodeId] = useState<string | null>(null);

  const onNodeMouseEnter: NodeMouseHandler = (_event, node) => {
    if (!isNodeHoverable(node)) {
      return;
    }
    setHoveredMethodId(node.data.methodId);
    setHoveredNodeId(node.id);
  };

  const onNodeMouseLeave: NodeMouseHandler = (_event, node) => {
    if (isNodeHoverable(node)) {
      setHoveredMethodId(null);
      setHoveredNodeId(null);
    }
  };

  return {hoveredMethodId, hoveredNodeId, onNodeMouseEnter, onNodeMouseLeave};
}
